import { render, staticRenderFns } from "./privacy-policy.vue?vue&type=template&id=41ecf400&scoped=true&"
var script = {}
import style0 from "./privacy-policy.vue?vue&type=style&index=0&id=41ecf400&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ecf400",
  null
  
)

component.options.__file = "privacy-policy.vue"
export default component.exports